import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const BlackPointType = types.compose(
  BaseEntity,
  types.model('BlackPointType', {
    blackPointTypeId: types.identifierNumber,
    code: types.maybe(types.string),
    name: types.maybe(types.string),
    orderNr: types.number,
  }),
);
